// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web — features/whatsappCloud/useWhatsAppCloud.ts
// ════════════════════════════════════════════════════════════════════════════

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { whatsappCloudService } from './service';
import type { SalvarWhatsAppCloudRequest, OnboardWhatsAppRequest } from './types';

const KEY = ['whatsapp-cloud', 'config'] as const;

export function useWhatsAppCloud() {
  const qc = useQueryClient();

  const query = useQuery({
    queryKey: KEY,
    queryFn:  whatsappCloudService.getConfig,
  });

  const salvar = useMutation({
    mutationFn: (req: SalvarWhatsAppCloudRequest) => whatsappCloudService.salvar(req),
    onSuccess:  () => qc.invalidateQueries({ queryKey: KEY }),
  });

  const teste = useMutation({
    mutationFn: ({ numero, texto }: { numero: string; texto?: string }) =>
      whatsappCloudService.teste(numero, texto),
  });

  const seedTemplates = useMutation({
    mutationFn: () => whatsappCloudService.seedTemplates(),
  });

  // Valores públicos p/ o Embedded Signup (App Id / config_id). Raramente mudam.
  const embeddedConfig = useQuery({
    queryKey: ['whatsapp-cloud', 'embedded-config'] as const,
    queryFn:  whatsappCloudService.getEmbeddedConfig,
    staleTime: Infinity,
    retry: false,
  });

  const onboarding = useMutation({
    mutationFn: (req: OnboardWhatsAppRequest) => whatsappCloudService.onboarding(req),
    onSuccess:  () => qc.invalidateQueries({ queryKey: KEY }),
  });

  return { query, salvar, teste, seedTemplates, embeddedConfig, onboarding };
}
